export default __webpack_public_path__ + "static/media/kaduna-terminal.46d772da.png";